import { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { CashoutSlice, GetCashoutlist } from "../../redux/slices/cashoutreq";
import { useNavigate } from "react-router";
import { toast } from "react-toastify";
import ListofCashouts from "../../components/dashboard/cashout";
import { rotate } from "../../components/rotate/RefreshRotateAnimation";
import { IconButton } from "@mui/material";
import RefreshIcon from "@mui/icons-material/Refresh";
import { ablyClient, sendCashout } from "../../lib/socket";
import CashoutPaymentModal from "../../components/modal/cashoutmodal";

const Cashout = () => {
  const [amount, setAmount] = useState(0);
  const [selectedAmount, setSelectedAmount] = useState(0);
  const [showModal, setShowModal] = useState(false);
  const [modalError, setModalError] = useState(""); // Error for modal
  const [pageError, setPageError] = useState(""); // Error for page
  const { user } = useSelector((state) => state.login);
  const balance = useSelector((value) => value?.ubal?.data?.balance);
  const predefinedAmounts = [50, 100, 150, 200, 250];
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const handleAmountClick = (amount) => {
    setSelectedAmount(amount);
    setAmount(amount);
  };

  const handleProceed = () => {
    setPageError("");

    if (amount < 50) {
      toast.error("Please add a minimum of $50");
      return;
    }
    if (!amount && !selectedAmount) {
      setPageError("Please enter or select an amount.");
      return;
    }
    if (amount) {
      setSelectedAmount(amount); // If user enters an amount, set it as selected
    }
    if (parseInt(amount) > parseInt(balance)) {
      return toast.error("Your balance is too low!");
    } else {
      setShowModal(true);
    }
  };

  const handleConfirm = async ({ method, accountValue }) => {
    setModalError("");

    if (parseInt(balance) >= parseInt(amount) && parseInt(balance) > 0) {
      const payload = {
        id: user?.id,
        amount: selectedAmount,
        cashoutMethod: method,
        cashoutDetail: accountValue,
      };
      const userid = user?.id;
      await dispatch(CashoutSlice(payload, navigate));
      await sendCashout("admin-cashout", userid, "admin-456", "private-cash");

      setShowModal(false);
      setSelectedAmount(0);
      setAmount("");
    } else {
      toast.error("Your balance is too low!");
    }
  };

  const { loading } = useSelector((u) => u?.cash);
  const handleRefresh = () => {
    dispatch(GetCashoutlist());
  };

  useEffect(() => {
    const channel = ablyClient.channels.get("admin-cashout");
    const userid = user?.id;
    const messageHandler = (message) => {
      const { senderId, receiverId, text } = message.data;

      if (senderId === userid) {
        dispatch(GetCashoutlist());
      }
    };

    channel.subscribe("private-cash", messageHandler);

    return () => {
      channel.unsubscribe("private-cash", messageHandler);
    };
  }, []);
  return (
    <>
      <div className="rounded-lg shadow-lg custom-container mx-auto mt-5 pl-3 w-full sm:w-full md:w-full xl:w-full pb-20">
        {/* Balance Section */}
        <div className="flex justify-between items-center mb-3 px-1">
          <span className="text-lg font-semibold text-white">
            Your Balance
            <IconButton
              onClick={handleRefresh}
              disabled={loading}
              sx={{
                ml: 2,
                animation: loading ? `${rotate} 1s linear infinite` : "none",
                backgroundColor: "#e00e84",
                color: "white",
                "&:hover": {
                  backgroundColor: "#e00e84",
                },
                "&:disabled": {
                  backgroundColor: "#c74d98",
                },
              }}
            >
              <RefreshIcon />
            </IconButton>
          </span>
          <span className="text-lg font-semibold text-white mr-4">
            ${balance ? balance : 0}
          </span>
        </div>
        {/* Withdraw Amount Section */}
        <div className="flex flex-col md:flex-row items-center">
          <div className="flex space-x-2 mb-0">
            {predefinedAmounts.map((value) => (
              <div
                key={value}
                onClick={() => handleAmountClick(value)}
                className={`cursor-pointer border-2 rounded-md p-2 w-14 sm:w-20 text-center ${
                  selectedAmount === value
                    ? "bg-[#e2008a] text-white"
                    : "gradient-btns text-black font-bold border-[#000]"
                }`}
              >
                ${value}
              </div>
            ))}
          </div>

          {/* Input Field and Proceed Button */}
          <div className="flex flex-col mr-3 md:flex-row items-center w-full md:w-auto mt-4 ml-2">
            {/* Input Field */}
            <div className="relative flex items-center w-full md:w-2/2 xl:w-[330px] 2xl:w-[530px]">
              <input
                type="text"
                id="withdraw-amount"
                value={amount}
                min="0"
                max="6"
                onChange={(e) => setAmount(e.target.value)}
                placeholder=" Enter Add Amount"
                maxLength={6}
                className="bg-transparent border-2 mb-4 rounded-md p-[6px] border-[#fff] outline-none w-full"
              />
              <span className="absolute right-2 top-1 text-[20px]">$</span>
            </div>

            {/* Proceed Button */}
            <button
              onClick={handleProceed}
              className="bg-[#e2008a] text-white font-semibold h-10 mb-4 rounded-md transition duration-200 ml-2 w-full md:w-52 flex items-center justify-center"
            >
              {loading ? (
                <div
                  className="spinner-border text-light"
                  role="status"
                  style={{ height: "20px", width: "20px" }}
                >
                  <span className="visually-hidden">Loading...</span>
                </div>
              ) : (
                "Proceed"
              )}
            </button>
          </div>
        </div>
        {pageError && (
          <div className="text-red-500 text-lg mb-4">{pageError}</div>
        )}{" "}
        <ListofCashouts />
      </div>
      {/* Modal for Cashout Selection */}
      <CashoutPaymentModal
        open={showModal}
        onClose={() => setShowModal(false)}
        onConfirm={handleConfirm}
      />
      {/* <Modal
        show={showModal}
        onHide={() => {
          setShowModal(false);
          setSelectedCashoutMethod("");
          setInputValue("");
        }}
        backdrop="static"
        keyboard={false}
      >
        <Modal.Header closeButton>
          <Modal.Title className="text-black">Cashout</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div>
            <h5 className="text-black">Select Cashout Method:</h5>
            <select
              value={selectedCashoutMethod}
              onChange={(e) => {
                setSelectedCashoutMethod(e.target.value);
                setInputValue("");
                setModalError("");
              }}
              className="form-select mt-2"
            >
              <option value="">Select a method</option>
              {["MasterCard", "Chime", "Zelle"].map((method) => (
                <option key={method} value={method}>
                  {method.charAt(0).toUpperCase() + method.slice(1)}
                </option>
              ))}
            </select>
            {selectedCashoutMethod && (
              <div className="mt-2">
                <input
                  type="text"
                  value={inputValue}
                  onChange={(e) => setInputValue(e.target.value)}
                  placeholder={`Enter ${
                    selectedCashoutMethod.charAt(0).toUpperCase() +
                    selectedCashoutMethod.slice(1)
                  } Details`}
                  className="border-2 rounded-md p-[8px] outline-none w-full text-black mt-2"
                />
                {modalError && <div className="text-red-500">{modalError}</div>}
              </div>
            )}
          </div>
        </Modal.Body>
        <Modal.Footer className="justify-content-center ">
          <button
            className=" btn-secondary mx-2 bg-[#e50f87] px-3 py-2  rounded-md text-white"
            onClick={() => {
              setShowModal(false);
              setSelectedCashoutMethod("");
              setInputValue("");
            }}
          >
            Cancel
          </button>
          <button
            className="btn-primary mx-2 bg-[#e50f87] px-3 py-2  rounded-md text-white"
            onClick={handleConfirm}
            disabled={loading}
          >
            {loading ? "Processing..." : "Confirm"}
          </button>
        </Modal.Footer>
      </Modal> */}
    </>
  );
};

export default Cashout;
